import { Spin } from 'antd'

const Loading = () => {
  return (
    <div className="Loading">
      <Spin />
    </div>
  )
}

export default Loading
